import { BaseDataBind } from "./base";

/**
 * Data bind for an elements individual attribute.
 */
export class AttributeDataBind extends BaseDataBind
{
    public attributeName = 'data-bind-attribute';
    public selector = '[data-bind-attribute]';
    public eventNames = [];

    protected targetAttributeName: string;

    protected getPropertyValue(element: Element)
    {
        let name = super.getPropertyValue(element);
        let parts = name.split(':');
        this.targetAttributeName = parts[0];

        return parts[1];
    }

    public setElementValue(element: Element, value: any)
    {
        element.setAttribute(this.targetAttributeName, value);
    }

    public getElementValue(element: Element)
    {
        return element.getAttribute(this.targetAttributeName);
    }
}